import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/Navbar.js";
import Home from "./pages/Home.js";
import SignUp from "./pages/SignUp.js";
import SignIn from "./pages/SignIn.js";
import CreateEvent from "./pages/CreateEvent.js";
import EventDetail from "./pages/EventDetail.js";
import OrganizerDashboard from "./pages/OrganizerDashboard.js";
import "./styles/App.css";
// import FormBuilder from './pages/custom_form';  // we are using popuu now
import EditEvent from "./pages/EditEvent"; // Add this import
import DeleteEvent from "./components/DeleteEvent";
import DemoDashboard from "./pages/DemoDashboard";
import EventPage from "./pages/EventPage";
import FreeEventRegistrationForm from "./pages/FreeEventRegistrationForm";
import EventRegistrations from "./pages/EventRegistrations";
import RegistrationForm from "./pages/RegistrationForm";
import VerifiedAccount from "./pages/VerifiedAccount";
import AllEvent from "./pages/AllEvent";
import SpeakerForm from "./pages/SpeakerForm";
import SpeakerProfile from "./pages/SpeakerProfile";
import MainHeader from "./components/MainHeader.js";
import CategoryEvent from "./pages/CategoryEvent";
import GuidelinesBuilder from "./pages/GuidelinesBuilder.js";
import EventScheduler from "./pages/EventScheduler.js";
import { CityProvider } from "./context/CityContext";
import FAQPage from "./pages/FAQpage.js";
import TermsOfService from "./pages/Termsofservice.js";
import PrivacyPolicy from "./pages/PrivacyPolicy.js";
import ContactUs from "./pages/Contact.js";
import ScrollToTop from "./components/ScrollToTop.js";
// Import Cookie Banner and its provider

import { CookiesProvider } from "./contexts/CookiesContext";
import CookieBanner from "./components/CookieBanner.js";
import CookiePolicy from "./pages/CookiePolicy.js";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Help from "./pages/help.js";
import ShareableLinks from "./pages/HelpPages/ShareableLinks.js";
import HowToCreateEvent from "./pages/HelpPages/HowToCreateEvent.js";
import HowToRegisterAsAttendee from "./pages/HelpPages/HowToRegisterAsAttendee.js";
import SpeakerManagementPage from "./pages/SpeakerManagementPage.js";
import AttendeeManagementPage from "./pages/AttendeeManagementPage.js";
import HowToRegisterAsSpeaker from "./pages/HelpPages/HowToRegisterAsSpeaker.js";
import HowToSignUp from "./pages/HelpPages/HowToSignUp.js";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isBannerVisible, setIsBannerVisible] = useState(false);

  useEffect(() => {
    try {
      const userData = localStorage.getItem("user");
      // Clear localStorage if it contains "undefined" string
      if (userData === "undefined" || userData === "null") {
        localStorage.removeItem("user");
      } else if (userData) {
        setUser(JSON.parse(userData));
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
      localStorage.removeItem("user");
    } finally {
      setLoading(false);
    }
  }, []);

  const handleSignOut = () => {
    localStorage.removeItem("user");
    setUser(null);
  };

  const handleBannerVisibility = (visible) => {
    setIsBannerVisible(visible);
    // Adjust body padding when banner is visible to prevent content hiding
    if (visible) {
      document.body.style.paddingBottom = "280px";
    } else {
      document.body.style.paddingBottom = "0";
    }
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      document.body.style.paddingBottom = "0";
    };
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div className="spinner">Loading...</div>
      </div>
    );
  }

  return (
    <CityProvider>
      <CookiesProvider>
        <Router>
          <MainContent
            user={user}
            setUser={setUser}
            handleSignOut={handleSignOut}
            onBannerVisibilityChange={handleBannerVisibility}
          />
        </Router>
      </CookiesProvider>
    </CityProvider>
  );
}

// Separate component that uses useLocation
function MainContent({ user, setUser, handleSignOut, onBannerVisibilityChange }) {
  return (
    <div className="App">
      {user ? <Navbar user={user} onSignOut={handleSignOut} /> : <MainHeader />}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/signup"
          element={
            user ? <Navigate to="/dashboard" /> : <SignUp setUser={setUser} />
          }
        />
        {/* ADD VERIFICATION ROUTES HERE */}
        <Route path="/verify_account/:token" element={<VerifiedAccount />} />
        <Route path="/verify_account" element={<VerifiedAccount />} />

        <Route
          path="/signin"
          element={
            user ? <Navigate to="/dashboard" /> : <SignIn setUser={setUser} />
          }
        />
        <Route path="/demo" element={<DemoDashboard />} />
        <Route
          path="/create-event"
          element={user ? <CreateEvent /> : <Navigate to="/signin" />}
        />
        <Route path="/event/:id" element={<EventDetail user={user} />} />
        <Route
          path="/event/:id/registrations"
          element={<EventRegistrations />}
        />

        <Route
  path="/attendee-management/:eventId"
  element={
    user ? (
      <AttendeeManagementPage />
    ) : (
      <Navigate to="/signin" />
    )
  }
/>
        <Route path="/edit-event/:id" element={<EditEvent />} />
        <Route path="/event/:eventId/delete" element={<DeleteEvent />} />
        <Route
          path="/dashboard"
          element={
            user ? (
              <OrganizerDashboard user={user} />
            ) : (
              <Navigate to="/signin" />
            )
          }
        />
        <Route
          path="/free-event-register/event/:id"
          element={<FreeEventRegistrationForm />}
        />
        <Route path="/register" element={<RegistrationForm />} />
        <Route path="/eventpage/:id" element={<EventPage />} />
        <Route path="/all-event" element={<AllEvent />} />
        <Route path="/category/:event_type" element={<CategoryEvent />} />
        <Route path="/speaker-form/event/:id" element={<SpeakerForm />} />

        <Route
  path="/speaker-management/:eventId"
  element={
    user ? (
      <SpeakerManagementPage />
    ) : (
      <Navigate to="/signin" />
    )
  }
/>
        <Route path="/speaker-profile/:id" element={<SpeakerProfile />} />
        <Route path="/guidelines/:id" element={<GuidelinesBuilder />} />
        <Route path="/scheduler/:id" element={<EventScheduler />} />

        <Route path="/faq" element={<FAQPage />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
       


           <Route path="/help" element={<Help />} />

        
        <Route path="/contact" element={<ContactUs />} />


        <Route
  path="/how_to_get_sharable_link"
  element={<ShareableLinks />}
/>

<Route
    path="/how_to_create_event"
    element={<HowToCreateEvent />}
/>

<Route
    path="/how_to_register_as_attendee"
    element={<HowToRegisterAsAttendee />}
/>

<Route
  path="/how_to_register_as_speaker"
  element={<HowToRegisterAsSpeaker />}
/>


<Route path="/how_to_sign_up" element={<HowToSignUp />} />

        {/* Catch-all route */}
        <Route path="*" element={<div>404 - Page Not Found</div>} />

 <Route path="/cookie-policy" element={<CookiePolicy />} />
      </Routes>

      {/* Cookie Banner - Will appear on all pages */}
      <CookieBanner onVisibilityChange={onBannerVisibilityChange} />


<ToastContainer
  position="top-right"
  autoClose={3000}
  hideProgressBar={false}
  newestOnTop
  closeOnClick
  pauseOnHover
/>
     
    </div>
  );
}

export default App;